import script from "./plus-free-access-countdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./plus-free-access-countdown.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__